/**
 * 过滤多个字段数据
 * @param searchValue 搜索值
 * @param fieldnames 过滤多个字段
 * @param option 行数据
 */
export function filterOptionFieldnames(searchValue: string, fieldnames: string | string[], option: any): boolean {
  if (typeof fieldnames === 'string') {
    return filterOptionFieldname(searchValue, fieldnames, option);
  }
  if (Array.isArray(fieldnames) && fieldnames.length) {
    for (let index = 0; index < fieldnames.length; index++) {
      const element = fieldnames[index];
      const flag = filterOptionFieldname(searchValue, element, option);
      if (flag) return true;
    }
    return false;
  }
  return true;
}
/**
 * 过滤单个字段数据
 * @param searchValue 搜索值
 * @param fieldname 字段名称
 * @param option 行数据
 */
export function filterOptionFieldname(searchValue: string, fieldname: string, option: any): boolean {
  if (!searchValue) return true;
  const fieldnameValue = option[fieldname];
  if (typeof fieldnameValue === 'string') {
    return fieldnameValue.includes(searchValue);
  }
  return true;
}
